var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgX1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 25,
    viewBox: "0 0 22 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4181 20.5377L3.44036 5.13766C3.15937 4.7764 3.41682 4.25 3.8745 4.25H6.14763C6.31735 4.25 6.47757 4.32836 6.58177 4.46234L18.5595 19.8623C18.8406 20.2237 18.5831 20.75 18.1254 20.75H15.8523C15.6826 20.75 15.5223 20.6716 15.4181 20.5377Z",
    stroke: "white",
    strokeWidth: 1.46667
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3334 4.25L3.66675 20.75",
    stroke: "white",
    strokeWidth: 1.46667,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX1);
export default __webpack_public_path__ + "static/media/x-1.15a1dd7f98be306de20c9145c1c7fd5d.svg";
export { ForwardRef as ReactComponent };